import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import equipmentService from "../../../Services/inventoryService";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";

const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

const UpdateEquipment = () => {
  const [equipmentData, setEquipmentData] = useState({
    cost_of_maintenance: "",
    date_of_condemnation: "",
    date_of_replacement: "",
    other_relevant_remarks: "",
  });

  const { id }    = useParams();
  const { state } = useLocation();
  const navigate  = useNavigate();

  useEffect(() => {
    if (state?.equipment) {
      const eq = state.equipment;
      setEquipmentData({
        cost_of_maintenance:    eq.cost_of_maintenance    || "",
        date_of_condemnation:   eq.date_of_condemnation   || "",
        date_of_replacement:    eq.date_of_replacement    || "",
        other_relevant_remarks: eq.other_relevant_remarks || "",
      });
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEquipmentData({ ...equipmentData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        cost_of_maintenance:    equipmentData.cost_of_maintenance,
        date_of_condemnation:   equipmentData.date_of_condemnation,
        date_of_replacement:    equipmentData.date_of_replacement,
        other_relevant_remarks: equipmentData.other_relevant_remarks,
      };
      await equipmentService.update(id, payload);
      toast.success("Equipment updated successfully!");
      navigate(-1);
    } catch (error) {
      toast.error("Error updating equipment.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-6 sm:py-10 px-3 sm:px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="bg-[#2F6DB4] px-5 sm:px-8 py-4 sm:py-5">
            <h1 className="text-white text-[16px] sm:text-[18px] font-[500] tracking-tight">
              Update Equipment
            </h1>
            <p className="text-blue-200 text-[11px] sm:text-[12px] mt-0.5">
              Fill in all fields to update the equipment maintenance record
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-5 sm:px-8 py-5 sm:py-6">

              <SectionLabel>Maintenance Information</SectionLabel>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <InputField
                  label="Cost of Maintenance"
                  type="text"
                  name="cost_of_maintenance"
                  placeholder="e.g. Rs. 10,000"
                  value={equipmentData.cost_of_maintenance}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Date of Condemnation"
                  type="date"
                  name="date_of_condemnation"
                  value={equipmentData.date_of_condemnation}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                <InputField
                  label="Date of Replacement"
                  type="date"
                  name="date_of_replacement"
                  value={equipmentData.date_of_replacement}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Other Remarks"
                  type="text"
                  name="other_relevant_remarks"
                  placeholder="Additional notes"
                  value={equipmentData.other_relevant_remarks}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="border-t border-gray-100 mt-8 pt-5 flex flex-col-reverse sm:flex-row items-center sm:justify-between gap-3">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="w-full sm:w-auto text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500] text-center"
                >
                  <FaArrowLeftLong className="inline mb-0.5" />  Cancel
                </button>
                <button
                  type="submit"
              className="relative overflow-hidden bg-[#2F6DB4] text-white text-[12px] sm:text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500 whitespace-nowrap">
                
                  Update Equipment  <FaArrowRightLong className="inline mb-0.5" />
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields marked as required must be filled before saving.
        </p>
      </div>
    </div>
  );
};

export default UpdateEquipment;